import {
  ModalContent,
  ModalRoot,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { ModalHeader, ModalTitle } from '@synoptic/ui-kit/modal/modal.tsx';
import { FC, ReactNode, useState } from 'react';
import { EditProfileForm } from '@/routes/_app.$username/profile-card/main-statistics/identity/edit-profile/edit-profile-form/edit-profile-form.tsx';
import { useUpdateUserProfile } from '@/routes/_app.$username/profile-card/main-statistics/identity/edit-profile/edit-profile-form/use-update-user-profile.ts';

export type EditProfileProps = {
  trigger: ReactNode;
  backgroundImageKey?: string;
};

export const EditProfileModal: FC<EditProfileProps> = ({
  trigger,
  backgroundImageKey,
}) => {
  const [open, onOpenChange] = useState(false);
  const [updateUserProfile] = useUpdateUserProfile();

  const onSubmit = (input: { fullName: string; bio?: string }) => {
    updateUserProfile(input);
    onOpenChange(false);
  };

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Edit profile</ModalTitle>
        </ModalHeader>

        <EditProfileForm
          onSubmit={onSubmit}
          backgroundImageKey={backgroundImageKey}
        />
      </ModalContent>
    </ModalRoot>
  );
};
